module.exports = __webpack_public_path__ + "images/nest-0539eda97792027ba81156b3f4cd846c.jpg";